<template>
  <card-actions
    placement="bottom-end"
    button-class="text-sm font-bold text-primary-600 hover:text-primary-700 transition-all transition-normal"
    @show="scrollToLastMessage"
  >
    <template #icon>
      Notes ({{ messages.length }})
    </template>
    <div class="w-screen max-w-xs text-sm border-t-2 border-black">
      <div
        ref="messages"
        class="h-64 overflow-auto max"
      >
        <article
          v-for="log in messages"
          :key="log.id"
          class="p-2 border-b border-grey-100 relative"
        >
          <div v-html="parseMarkdown(log.message)" />
          <p class="italic text-grey-700">
            {{ log.created_by_user ? log.created_by_user.name : 'User No Longer Exisits' }} - {{ format(parseISO(log.created_at), 'dd/MM/yy') }}
          </p>
          <template v-if="$AuthUser.id === log.created_by">
            <button
              type="button"
              class="text-negative-800 font-bold absolute pin-t pin-r p-2"
              @click="deleteNote(log.id)"
            >
              &times;
              <span class="sr-only">Delete</span>
            </button>
          </template>
        </article>
      </div>
      <form
        class="flex border-t-2 border-grey-200 -mt-px items-end"
        @submit.prevent="addNote"
      >
        <textarea
          v-model.trim="message"
          class="flex-1 p-2 focus:outline-none focus:shadow-outline resize-none"
          rows="3"
          placeholder="Enter your message here..."
          :disabled="loading"
        ></textarea>
        <button
          type="submit"
          class="m-2 px-4 py-2 focus:outline-none focus:shadow-outline text-black font-bold rounded-sm"
          :class="{
            'bg-primary-100 hover:bg-primary-200': message.length && !loading,
            'bg-grey-300': !message.length || loading
          }"
          :disabled="!message.length || loading"
        >
          Add
        </button>
      </form>
    </div>
  </card-actions>
</template>

<script>
export default {
  name: "FundingSubmissionNotes",
  props: {
    logs: {
      type: Array,
      required: true
    },
    applicationUuid: {
      type: String,
      required: true,
    }
  },
  data(){
    return {
      loading: false,
      messages: [...this.logs],
      message: ''
    }
  },
  methods: {
    scrollToLastMessage() {
      const messages = this.$refs.messages;
      this.$nextTick(() => messages.scrollTop = messages.scrollHeight)

    },
    addNote() {
      this.loading = true
      axios.post(this.route('log.add', {
        application: this.applicationUuid
      }), {
        message: this.message
      })
      .then(({data}) => {
        this.messages.push(data.log)
        this.scrollToLastMessage()
      })
      .finally(() => {
        this.loading = false
        this.message = ''
      })
    },
    deleteNote(messageId) {
      if(!confirm('Are you sure your want to delete this message?')) return
      this.loading = true
      axios.delete(this.route('log.delete', {
        application: this.applicationUuid,
        log: messageId
      }))
      .then(() => {
          const messageIndex = this.messages.findIndex(message => message.id === messageId)
          if(messageIndex > -1) {
            this.messages.splice(messageIndex, 1)
          }
      })
      .finally(() => this.loading = false)
    }
  }
}
</script>
